import RepositoryBase from "./repositoryBase";
import type BackOfficeConnector from "../data/backOfficeConnector";
import type EventBus from "../services/eventBus";
import type { AxiosResponse } from "axios";
import { serializeFilters } from "../utils/filters";
import type SubLedgerReportSearchRequest from "../entities/subLedgerReportSearchRequest";
import type { IPagination } from "../data/types";
import SubLedgerReportResponse from "../entities/subLedgerReportResponse";
import type SubLedgerReportRequest from "../entities/subLedgerReportRequest";
import SubLedgerReportPreviewResponse from "../entities/subLedgerReportPreviewResponse";

export default class AccountingSubLedgerReportsRepository extends RepositoryBase<BackOfficeConnector> {
  constructor(protected apiFactory: ReturnType<typeof BackOfficeConnector.Factory>, protected eventBus: EventBus) {
    super(apiFactory, eventBus);
  }

  getAll(pagination: IPagination, filters: SubLedgerReportSearchRequest) {
    return this.callApi(api =>
      api
        .all("finance")
        .all("accounting")
        .all("sub_ledger_report_search")
        .postPagedEntities(serializeFilters({ ...filters, ...pagination }, false), SubLedgerReportResponse)
    );
  }

  async downloadReport(reportId: string): Promise<AxiosResponse<File>> {
    return this.callApi(
      api => api.all("finance").all("accounting").one("sub_ledger_reports", reportId).one("file").getRaw() as any
    );
  }

  preview(request: SubLedgerReportRequest) {
    return this.callApi(api =>
      api.all("finance").all("accounting").all("sub_ledger_report_preview").postEntity(request, SubLedgerReportPreviewResponse)
    );
  }

  createReport(request: SubLedgerReportRequest) {
    return this.callApi(api =>
      api.all("finance").all("accounting").all("sub_ledger_reports").postEntity(request, SubLedgerReportResponse)
    );
  }
}
